import React from 'react';
import { connect } from 'react-redux';

// Store
import { eventActions } from "../Store/Actions/eventActions";
import { getEventData } from "../Store/Selectors/selectors"
import { log } from "../Helpers/logger";

/////////////////////////////////////////////////////////////////////////////////////////
// EventBox
/////////////////////////////////////////////////////////////////////////////////////////

class EventBox extends React.Component {
    // LIFECYCLE FUNCTIONS ====================================================

    // ------------------------------------------------------------------------
    render(){
        log.ui.log('EventBox::render', this.props);
        const { message, speaker } = this.props.eventData;

        return(
            <div className="bg-gray-800 rounded-xl shadow-lg overflow-hidden mt-4">
                <div className="bg-gray-700 px-4 py-2 text-lg font-semibold border-b border-gray-600">
                    Événement
                </div>
                <div className="p-4 overflow-auto h-[300px]">
                    <div className="bg-gray-700/50 rounded-lg overflow-hidden max-w-2xl">
                        <div className="flex flex-col md:flex-row">
                            <div className="md:w-1/3 flex-shrink-0">
                                {speaker && (
                                    <img 
                                        src={speaker.img} 
                                        alt={speaker.name || "Personnage"} 
                                        className="w-full max-w-[164px] mx-auto"
                                    />
                                )}
                            </div>
                            <div className="md:w-2/3 p-4">
                                {speaker && <h3 className="text-xl font-bold text-yellow-300 mb-2">{speaker.name}</h3>}
                                <p className="text-gray-300 mb-4">{message}</p>
                                <p className="text-gray-200 font-bold mb-3">Que voulez-vous répondre ?</p>
                                <div className="flex flex-wrap gap-2">
                                    {this._showActions()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    // PRIVATE FUNCTIONS ======================================================

    // ------------------------------------------------------------------------
    _showActions(){
        let { actions } = this.props.eventData;

        return Object.values(actions).map((answer, index) => {
            return (
                <button 
                    type="button"
                    key={index}
                    className="bg-gray-700 hover:bg-gray-600 text-gray-200 px-3 py-2 rounded-lg transition-colors duration-200"
                    onClick={() => this._handleAction(index)}
                >
                    {answer.label}
                </button>
            )
        });
    }
    
    // ------------------------------------------------------------------------
    _handleAction(actionIndex) {
        const { dispatch } = this.props;
        dispatch(eventActions.sendActionIndex(actionIndex));
    }
}

/////////////////////////////////////////////////////////////////////////////////////////

const mapStateToProps = (state) => {
    return {
        eventData: getEventData(state)
    };
}

export default connect(mapStateToProps)(EventBox);
